<template>
  <!-- SELECTION DU SITE -->
  <v-select
    dense
    v-model="site"
    :items="$store.state._Sites.sites"
    item-text="LIC_URL"
    item-value="LIC_ID"
    :label="$t('select') + ' ' + $tc('sites', 1, {count: ''}) | cap"
    return-object
    @input="updateSite()"
    prepend-icon="language"
  ></v-select>
    <!-- autocomplete -->
</template>

<script>
import _ from 'lodash'
export default {
  data () {
    return {
      site: null
    }
  },

  created () {
    this.site = _.clone(this.$store.state._Sites.siteSelected)
  },

  methods: {
    updateSite () {
      this.$store.commit('_Sites/UPDATE_SITE_SELECTED', this.site)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzSelectOneSite.vue